import { get as nestedGet } from 'nested-property'
import { PopulatedAssessment, User } from '../types'
import { Assessment } from '../types/assessments/assessment'

export const getCorrectedValue = (
  assessment?: Assessment | PopulatedAssessment | null,
  path?: string,
) => {
  const formData = (assessment as Assessment)?.data ?? (assessment as any)?.formData ?? {}

  return nestedGet(assessment?.corrections, path ?? '') || nestedGet(formData, path ?? '')
}

export const getInsuranceProviderId = (user?: User | null) =>
  user?.insurancePlans?.primary?.insuranceProviderId
